module.exports = __webpack_public_path__ + "static/dont-touch-my-hair-002d9f0eacf366fb3cad21cd071550d2.jpg";